export default "__VITE_ASSET__68__n$_e__"